export default __webpack_public_path__ + "static/media/craon6.1d7b552d.jpg";